<template>
	<div>
		<el-row style="padding: 20px;">
			<el-descriptions title="系统信息">
			  <el-descriptions-item class="os-item" label="CPU信息">
			    <span>制造商：{{ sysInfo.cpu.manufacturer +' '}}</span>
			    <span>品牌：{{ sysInfo.cpu.brand +' '}}</span>
			    <span>核心数：{{ sysInfo.cpu.cores +' '}}</span>
			  </el-descriptions-item>
			  <el-descriptions-item class="os-item" label="内存信息">
			   <span>总计：{{ (sysInfo.mem.total / (1024 * 1024 * 1024)).toFixed(2) +' '}} GB</span>
			     <span>可用：{{ (sysInfo.mem.available / (1024 * 1024 * 1024)).toFixed(2) +' '}} GB</span>
			     <span>已用：{{ (sysInfo.mem.used / (1024 * 1024 * 1024)).toFixed(2) +' '}} GB</span>
			  </el-descriptions-item>
			  <el-descriptions-item class="os-item" label="操作系统信息">
			    <span>平台：{{ sysInfo.osinfo.platform +' '}}</span>
			    <span>发行版：{{ sysInfo.osinfo.distro +' '}}</span>
			    <span>版本：{{ sysInfo.osinfo.release +' '}}</span>
			  </el-descriptions-item>
			</el-descriptions>
			
		</el-row>
		<el-row style="position: relative;padding: 20px;">
			<el-button style="position: absolute;z-index: 9999;left: 20px;top: -20px;" type="primary" size="mini" @click="handleAdd">
				新增用户
			</el-button>
			<el-table
			  :data="userList.slice((currentPage-1)*pageSize,currentPage*pageSize)"
			  tooltip-effect="dark"
			  style="width: 100%"
			  height="600px"
			  :header-cell-style="{background:'#FAFAFA'}">
			  <el-table-column prop="username" label="账号" ></el-table-column>
			  <el-table-column prop="nickName" label="昵称" ></el-table-column>
			  <el-table-column show-overflow-tooltip prop="password" label="密码" ></el-table-column>
			  <el-table-column prop="userType" label="用户类型" >
				<template slot-scope="scope">
				  <el-select disabled v-model="scope.row.userType" placeholder="请选择账号类型">
				    <el-option label="管理用户" value="2001"></el-option>
				    <el-option label="普通用户" value="1001"></el-option>
				  </el-select>
				</template>
			  </el-table-column>
			  <el-table-column label="操作" width="220">
				<template slot-scope="scope">
				  <el-button size="mini" type="text" :loading="loading" @click="handleEdit(scope.row)">修改</el-button>
				  <!-- <el-button size="mini" type="text" :loading="loading" @click="handleRest(scope.$index, scope.row)">重置</el-button> -->
				  
				  <el-button size="mini" type="text" :loading="loading" @click="handleDelete(scope.row)">删除</el-button>

				</template>
			  </el-table-column>
			</el-table>
			  <!-- 分页器 -->
			  <div class="block">
				<el-pagination
				  @size-change="handleSizeChange"
				  @current-change="handleCurrentChange"
				  :current-page="currentPage"
				  :page-sizes="[8,9,10,11,12,13,14,15,16]"
				  :page-size="pageSize"
				  layout="total, sizes, prev, pager, next, jumper"
				  :total="total">
				</el-pagination>
			  </div>
		</el-row>
		
		<el-dialog
		  title="新增用户"
		  :visible.sync="addDialogVisible"
		  width="45%"
		  center>
		  <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
		    <el-form-item label="账户" prop="username">
		      <el-input size="mini" v-model="ruleForm.username"></el-input>
		    </el-form-item>
		    <el-form-item label="用户密码" prop="password">
		      <el-input size="mini" v-model="ruleForm.password"></el-input>
		    </el-form-item>
		    <el-form-item label="姓名" prop="nickName">
		      <el-input size="mini" v-model="ruleForm.nickName"></el-input>
		    </el-form-item>
		    <el-form-item label="账号类型" prop="userType">
		      <el-select size="mini" v-model="ruleForm.userType" placeholder="请选择账号类型">
		        <el-option label="管理用户" value="2001"></el-option>
		        <el-option label="普通用户" value="1001"></el-option>
		      </el-select>
		    </el-form-item>
		
		    <el-form-item style="width: 100%;display: flex;justify-content: center;">
		      <el-button @click="addDialogVisible=false">取消</el-button>
		      <el-button type="primary" @click="submit('add')">提交</el-button>
		    </el-form-item>
		  </el-form>
		</el-dialog>
		
		<el-dialog
		  title="修改用户信息"
		  :visible.sync="updateDialogVisible"
		  width="45%"
		  center>
		  <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
		    <el-form-item label="账户" prop="username">
		      <el-input readonly size="mini" v-model="ruleForm.username"></el-input>
		    </el-form-item>
		    <el-form-item label="用户密码" prop="password">
		      <el-input size="mini" v-model="ruleForm.password"></el-input>
		    </el-form-item>
		    <el-form-item label="姓名" prop="nickName">
		      <el-input size="mini" v-model="ruleForm.nickName"></el-input>
		    </el-form-item>
		    <el-form-item label="账号类型" prop="userType">
		      <el-select readonly size="mini" v-model="ruleForm.userType" placeholder="请选择账号类型">
		        <el-option label="管理用户" value="2001"></el-option>
		        <el-option label="普通用户" value="1001"></el-option>
		      </el-select>
		    </el-form-item>
		
		    <el-form-item style="width: 100%;display: flex;justify-content: center;">
		      <el-button @click="updateDialogVisible=false">取消</el-button>
		      <el-button type="primary" @click="submit('update')">提交</el-button>
		    </el-form-item>
		  </el-form>
		</el-dialog>
	</div>
</template>

<script>
	
import {addUser,getAllUsers,deleteUser,getSysInfo,updateUser} from '@/api/index'
	
export default {
	name:'usermanager',
	components:{},
	data() {
		return {
			test:99,
			userList:[],
			currentPage:1,
			pageSize:10,
			loading:false,
			total:0,
			addDialogVisible:false,
			updateDialogVisible:false,
			ruleForm:{
				username:'',//账号
				nickName:'',//昵称
				password:'',//密码
				userType:'',//用户类型
				// status:'',//账号状态
			},
			rules:{
				username: [
				  { required: true, message: '必填', trigger: 'blur' },
				],
				nickName: [
				  { required: true, message: '必填', trigger: 'blur' },
				],
				password: [
				  { required: true, message: '必填', trigger: 'blur' },
				],
				userType: [
				  { required: true, message: '必填', trigger: 'blur' },
				],
				// status: [
				//   { required: true, message: '必填', trigger: 'blur' },
				// ],
			},
			sysInfo:{
				cpu:{},
				mem:{},
				osinfo:{}
			}
		}
	},
	created() {
		this.getList()
		getSysInfo().then(res => {
			console.log(res)
			this.sysInfo = res
		})
	},
	methods:{
		getList(){
			getAllUsers().then(res => {
				let users = []
				res.forEach(e => {
					users.push(JSON.parse(e))
				})
				this.userList = users
				this.total = users.length
			}).catch(err => {
				this.$message.error("获取用户列表异常")
			})
		},
		handleSizeChange(val){
			this.currentPage = 1;
		    this.pageSize = val;

		},
		handleCurrentChange(val){
			this.currentPage = val;

		},
		handleAdd(){
			this.addDialogVisible = true
			
		},
		handleEdit(row){
			this.updateDialogVisible = true
			this.ruleForm = JSON.parse(JSON.stringify(row))
		},
		submit(type){
			this.$refs["ruleForm"].validate(valid => {
				console.log(this.ruleForm)
				if(valid){
					if(type==='add'){
						addUser(this.ruleForm).then(res=>{
							this.$message.success("新增用户成功")
							this.resetForm()
							this.addDialogVisible = false
							this.getList()
						}).catch(err => {
							this.$message.error("新增用户异常")
						})
					}else{
						updateUser(this.ruleForm.userId,this.ruleForm).then(res=>{
							this.$message.success("更新用户信息成功")
							this.resetForm()
							this.updateDialogVisible = false
							this.getList()
						}).catch(err => {
							this.$message.error("新增用户异常")
						})
					}
					
				}
			})
			
		},
		resetForm(){
			this.ruleForm = {
				username:'',//账号
				nickName:'',//昵称
				password:'',//密码
				userType:'',//用户类型
				// status:'',//账号状态
			}
		},
		handleDelete(row) {
		      const id = row.userId;
		      
			  this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					deleteUser(id)
					this.$message.success("删除成功")
					this.getList()
				  }).catch(() => {
					this.$message({
					  type: 'info',
					  message: '已取消删除'
					});          
				  });
		},
	}
}
</script>

<style scoped>
.os-item{
	
}

</style>